import { memo } from "react";
import { IconProps, defaultIconProps } from "./icon.props.type";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { ThemeProvider, createTheme } from "@mui/material";

const ChevronDown = ({
  color = defaultIconProps.color,
  size = defaultIconProps.size,
}: IconProps) => {
  const theme = createTheme({
    palette: { primary: { main: color } },
  });

  return (
    <ThemeProvider theme={theme}>
      <KeyboardArrowDownRoundedIcon
        style={{ width: size, height: size }}
        color="primary"
      />
    </ThemeProvider>
  );
};

export default memo(ChevronDown);
